import { FC, useMemo } from 'react';

import { ReservationDate } from '@type-def_iqfu/public/ReservationAvailability';

import styles from './VisitReservationCalendar.module.scss';

const DAY_LABELS = ['日', '月', '火', '水', '木', '金', '土'];

const DISPLAY_DAYS = 28;
const COLUMNS = 14;

type Props = {
  dates: ReservationDate[];
};

const formatDate = (d: Date): string => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getDayOfWeekClass = (dayOfWeek: number) => {
  if (dayOfWeek === 0) return styles.sunday;
  if (dayOfWeek === 6) return styles.saturday;
  return '';
};

const VisitReservationCalendar: FC<Props> = ({ dates }) => {
  const days = useMemo(() => {
    const today = new Date();

    return [...Array(DISPLAY_DAYS)].map((_, i) => {
      const d = new Date(today);
      d.setDate(d.getDate() + i);
      const dateStr = formatDate(d);
      const dayOfMonth = d.getDate();
      const dateData = dates.find((item) => item.date === dateStr);

      return {
        date: dateStr,
        dayOfMonth,
        dayOfWeek: d.getDay(),
        monthLabel: i === 0 || dayOfMonth === 1 ? `${d.getMonth() + 1}/${dayOfMonth}` : undefined,
        isAvailable: !!dateData && dateData.slots.length > 0,
      };
    });
  }, [dates]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        {days.slice(0, COLUMNS).map((day) => (
          <span key={day.date} className={`${styles.day_label} ${getDayOfWeekClass(day.dayOfWeek)}`}>
            {DAY_LABELS[day.dayOfWeek]}
          </span>
        ))}
      </div>
      <div className={styles.calendar}>
        {days.map((day) => (
          <div key={day.date} className={styles.cell}>
            <span className={`${styles.day_number} ${getDayOfWeekClass(day.dayOfWeek)}`}>
              {day.monthLabel || day.dayOfMonth}
            </span>
            <span className={styles.availability_icon}>
              {day.isAvailable ? (
                <span className={styles.icon_available}>○</span>
              ) : (
                <span className={styles.icon_unavailable}>ー</span>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VisitReservationCalendar;
